import {compact} from '@benchling/js-utils';
import React, {useState} from 'react';

import {DEFAULT_VOLUME_UNITS} from 'constants/MeasurementConstants';
import {
  containerQuantityUnitTypePredicate,
  getCompatibilityFilterFromSymbols,
} from 'inventory/InventoryUnitUtil';
import SetAllDropdownWrapper from 'ui-library/SetAllDropdownWrapper';
import SearchableUnitDropdown from 'units/SearchableUnitDropdown';

export interface Props {
  allowNullUnits: boolean;
  onSetUnits: (units: string | null) => void;
  outputContainerQuantityUnits: Array<string | null>;
}

export default function BulkSetQuantityUnitsDropdown(props: Props): JSX.Element | null {
  const [units, setUnits] = useState<string | null>(DEFAULT_VOLUME_UNITS);
  const [unitId, setUnitId] = useState<string | null>(null);

  const handleSetUnits = (): void => {
    props.onSetUnits(units);
  };

  const nonNullSymbols = compact(props.outputContainerQuantityUnits);
  const unitTypeFilter =
    nonNullSymbols.length === 0
      ? containerQuantityUnitTypePredicate
      : getCompatibilityFilterFromSymbols(nonNullSymbols);
  if (!unitTypeFilter) {
    return null;
  }

  return (
    <SetAllDropdownWrapper isDisabled={false} onSetAll={handleSetUnits}>
      <SearchableUnitDropdown
        displaySelectionAsSymbol={true}
        includeNone={props.allowNullUnits}
        onSelect={(u) => {
          setUnits(u?.symbol ?? null);
          setUnitId(u?.id ?? null);
        }}
        selectedId={unitId}
        unitTypeFilter={unitTypeFilter}
      />
    </SetAllDropdownWrapper>
  );
}
